// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pedersen-verify-wrapper .el-row[data-v-15c5c116]{margin:0 calc(0px - var(--base-size-16))}.pedersen-verify-wrapper .el-row .el-col[data-v-15c5c116]{padding:0 var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
